import { Component } from '@angular/core';
import { FeatureAcknowledgementService } from '@app/services';
import { Features } from '@app/services/feature-acknowledgement.service';

const embedURL = 'https://www.humi.ca/employee-health-benefits/embed';

@Component({
    template: `<iframe
        id="embed"
        title="embed"
        height="95%"
        width="100%"
        style="border: none;"
        src="${embedURL}"
    ></iframe>`,
})
export class BenefitsUpsellView {
    constructor(private featureAcknowledgementService: FeatureAcknowledgementService) {}

    async ngOnInit(): Promise<void> {
        const hasAcknowledgedUpsell = await this.featureAcknowledgementService.hasAcknowledgedFeature(
            Features.benefitsUpsell
        );

        if (!hasAcknowledgedUpsell) {
            this.featureAcknowledgementService.acknowledgeFeature(Features.benefitsUpsell);
        }
    }
}
